import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const MailIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 5L8.91302 8.92462C11.4387 10.3585 12.5613 10.3585 15.087 8.92462L22 5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 19.5C10.0337 19.4939 9.56682 19.485 9.09883 19.4732C5.95033 19.3941 4.37608 19.3545 3.24496 18.2184C2.11383 17.0823 2.08114 15.5487 2.01577 12.4814C1.99475 11.4951 1.99474 10.5147 2.01576 9.52843C2.08114 6.46113 2.11382 4.92748 3.24495 3.79139C4.37608 2.6553 5.95033 2.61573 9.09882 2.53658C11.0393 2.4878 12.9607 2.48781 14.9012 2.53659C18.0497 2.61574 19.6239 2.65532 20.755 3.79141C21.8862 4.92749 21.9189 6.46114 21.9842 9.52844C21.9939 9.98251 21.9991 10.1965 21.9999 10.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 17C19 17.8284 18.3284 18.5 17.5 18.5C16.6716 18.5 16 17.8284 16 17C16 16.1716 16.6716 15.5 17.5 15.5C18.3284 15.5 19 16.1716 19 17ZM19 17V17.5C19 18.3284 19.6716 19 20.5 19C21.3284 19 22 18.3284 22 17.5V17C22 14.5147 19.9853 12.5 17.5 12.5C15.0147 12.5 13 14.5147 13 17C13 19.4853 15.0147 21.5 17.5 21.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MailIconDainty: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.19043 4L6.79911 6.61131C8.49816 7.574 9.21603 7.574 10.9151 6.61131L15.5238 4"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2.20094 8.98243C2.24452 11.0262 2.26632 12.048 3.0204 12.805C3.77448 13.5619 4.82398 13.5882 6.92298 13.641C8.21663 13.6735 9.49756 13.6735 10.7912 13.641C12.8902 13.5882 13.9397 13.5619 14.6938 12.805C15.4479 12.048 15.4697 11.0262 15.5132 8.98243C15.5273 8.3253 15.5273 7.6721 15.5132 7.01496C15.4697 4.97127 15.4479 3.94943 14.6938 3.19247C13.9397 2.43552 12.8902 2.40915 10.7912 2.35641C9.49756 2.32391 8.21663 2.32391 6.92298 2.35641C4.82398 2.40914 3.77448 2.43551 3.0204 3.19247C2.26631 3.94942 2.24452 4.97126 2.20094 7.01496C2.18692 7.6721 2.18693 8.3253 2.20094 8.98243Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
